import { render, staticRenderFns } from "./detail-arrow-up.vue?vue&type=template&id=184fe995&scoped=true&"
import script from "./detail-arrow-up.vue?vue&type=script&lang=js&"
export * from "./detail-arrow-up.vue?vue&type=script&lang=js&"
import style0 from "./detail-arrow-up.vue?vue&type=style&index=0&id=184fe995&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184fe995",
  null
  
)

export default component.exports